export default __webpack_public_path__ + "static/media/Anchor.b11cc36d.png";